import { RequestPasswordResetFormData } from '../../../entities/@forms/RequestPasswordResetForm/RequestPasswordResetForm'
import {
    FormErrors,
    FormValidation,
    validateEmailRegex,
    validateForm,
} from '../../../services/validationService'

export type RequestPasswordResetFormErrors = FormErrors<RequestPasswordResetFormData>;

export const validateRequestPasswordResetFormData = (formData: RequestPasswordResetFormData): FormValidation<RequestPasswordResetFormErrors> => {
    const errors: RequestPasswordResetFormErrors = {
        email: validateEmailRegex(formData.email),
    }

    return validateForm<RequestPasswordResetFormErrors>(errors)
}
